/**
 * Détermine si un mousedown cible un contrôle éditable (ou un descendant).
 * Utilisé par le panneau F8 AutoComplete pour ne pas appeler preventDefault
 * sur les critères de saisie (BL-0347).
 */
export function u2000IsEditableMouseDownTarget(target: EventTarget | null): boolean {
  if (target == null || !(target instanceof Element)) {
    return false;
  }
  return target.closest('input, textarea, select, [contenteditable="true"]') != null;
}
